/* global $:false */

import window from 'window'

export default class PopulateDataLayer {
  static init () {
    return Array.from($('.js-data-layer')).map((el) =>
      new PopulateDataLayer(el))
  }

  constructor (el) {
    const data = $(el).data()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }
}
